import classNames from 'classnames'
import { useState } from 'react'
import PopupMenu from '@/components/PopupMenu'
import AlignmentIcon from '@/components/icons/AlignmentIcon'
import { titleize } from '@/lib/string'



export default function AlignmentControl({alignX, alignY, onChange, disabled, onClose, onOpen}) {
  const alignment = [alignY, alignX].join('-')

  const [hovering, setHovering] = useState('')

  const labelAlignment = hovering || alignment
  const [labelY, labelX] = labelAlignment.split('-')
  let label = 'Align'

  if (labelAlignment) {
    if (labelAlignment === 'middle-center') label = 'Center'
    else if (labelX === 'center')           label = titleize(labelY)
    else if (labelY === 'middle')           label = titleize(labelX)
    else                                    label = titleize(labelY) + ' ' + titleize(labelX)
  }

  function handleChange (newAlignment) {
    const newAlignX = newAlignment.split('-')[1]
    const newAlignY = newAlignment.split('-')[0]

    onChange({alignX: newAlignX, alignY: newAlignY})
  }

  return <>
    <PopupMenu
      className="toolbar-button"
      small
      icon={<AlignmentIcon/>}
      disabled={disabled}
      onOpen={onOpen}
      onClose={onClose}
      tooltip="Alignment"
    >
      <div className='flex flex-col gap-1'>
        <div className='grid grid-cols-3'>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'top-left'       })} onPointerEnter={() => setHovering('top-left'       )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('top-left')}> <AlignmentIcon value="top-left"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'top-center'     })} onPointerEnter={() => setHovering('top-center'     )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('top-center')}> <AlignmentIcon value="top-center"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'top-right'      })} onPointerEnter={() => setHovering('top-right'      )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('top-right')}> <AlignmentIcon value="top-right"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'middle-left'    })} onPointerEnter={() => setHovering('middle-left'    )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('middle-left')}> <AlignmentIcon value="middle-left"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'middle-center'  })} onPointerEnter={() => setHovering('middle-center'  )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('middle-center')}> <AlignmentIcon value="middle-center"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'middle-right'   })} onPointerEnter={() => setHovering('middle-right'   )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('middle-right')}> <AlignmentIcon value="middle-right"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'bottom-left'    })} onPointerEnter={() => setHovering('bottom-left'    )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('bottom-left')}> <AlignmentIcon value="bottom-left"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'bottom-center'  })} onPointerEnter={() => setHovering('bottom-center'  )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('bottom-center')}> <AlignmentIcon value="bottom-center"/> </button>
          <button className={classNames('button tiny icon-button no-shadow hover_bg-light-blue', {'bg-light-blue': alignment === 'bottom-right'   })} onPointerEnter={() => setHovering('bottom-right'   )} onPointerLeave={() => setHovering('')} onClick={() => handleChange('bottom-right')}> <AlignmentIcon value="bottom-right"/> </button>
        </div>
        <div className='text-center dark-gray'>
          {label}
        </div>
      </div>
    </PopupMenu>
  </>
}